import { SxProps, Theme } from '@mui/material';

const headerContainer: SxProps<Theme> = {
  pb: '20px'
};

const titleText: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '60px',
  letterSpacing: '-2%',
  p: 0
};

const sourceExternallyButton: SxProps<Theme> = {
  p: 0
};

const createTalentPoolButton: SxProps<Theme> = {
  px: '24px',
  py: '16px',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px'
};

const header: SxProps = {
  flex: 1
};

export const candidateProfilePoolSx = {
  headerContainer,
  titleText,
  sourceExternallyButton,
  createTalentPoolButton,
  header
};
